import { OrderItem } from '@/types/order-list';
import { cn } from '@/utils/tailwind';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { Cell, Row, Table } from '@tanstack/react-table';
import { DragAlongCell } from './DragAlongCell';
import { deepEqual } from '@/utils/deep-equal';

interface TableBodyProps<TData extends object> {
  table: Table<TData>;
  checkedOrders?: OrderItem[];
  setCheckedOrders?: React.Dispatch<React.SetStateAction<OrderItem[]>>;
  columnOrder: string[];
}
export const TableBody = <TData extends object>({
  table,
  checkedOrders,
  setCheckedOrders,
  columnOrder,
}: TableBodyProps<TData>) => {
  const rows = table.getRowModel().rows;

  // ✅ 주문번호 그룹별 인덱스를 계산
  const groupMap = new Map<string, number>();
  let groupIndex = 0;
  rows.forEach((row) => {
    const orderNo = (row.original as any).orderNo;
    if (!groupMap.has(orderNo)) {
      groupMap.set(orderNo, groupIndex++);
    }
  });

  return (
    <tbody>
      {table.getRowModel().rows.map((row: Row<TData>) => {
        const order = row.original as OrderItem;

        const orderNo = (row.original as any).orderNo;
        const group = groupMap.get(orderNo) ?? 0;
        const isEven = group % 2 === 0;

        // 체크박스 여부: prop이 없으면 무조건 false
        const isChecked = checkedOrders?.some((o) => deepEqual(o, order)) ?? false;
        return (
          <tr
            key={row.id}
            className={cn(
              'group h-[60px] max-h-[60px]  cursor-pointer border-b border-gr-200  transition-colors duration-300',
              isEven && 'bg-gr-50',
              'hover:bg-[#f3f3f9]',
              isChecked && 'bg-point-100',
            )}
            // onClick={(e) => {
            //   if ((e.target as HTMLElement).closest('input[type="checkbox"]')) return;
            //   handleCheck(order, !isChecked); // ✅ Order 객체 전달
            // }}
          >
            {/* 체크박스 셀 */}
            {row
              .getVisibleCells()
              .filter((cell) => cell.column.id === 'checkbox')
              .map((cell: Cell<TData, unknown>) => (
                <DragAlongCell
                  key={cell.id}
                  order={order}
                  cell={cell}
                  disableDrag
                  checkedOrders={checkedOrders} // ✅ checkedOrders 전달
                />
              ))}

            {/* 나머지 셀 */}
            <SortableContext items={columnOrder} strategy={horizontalListSortingStrategy}>
              {row
                .getVisibleCells()
                .filter((cell) => cell.column.id !== 'checkbox')
                .map((cell: Cell<TData, unknown>) => (
                  <DragAlongCell key={cell.id} cell={cell} />
                ))}
            </SortableContext>
          </tr>
        );
      })}
    </tbody>
  );
};
